import { useRef } from 'react';

interface StoriesHeroProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

const StoriesHero = ({ searchQuery, onSearchChange }: StoriesHeroProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearchChange(inputRef.current?.value ?? '');
  };

  return (
    <section className="relative pt-32 pb-20 px-4 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/e8bd8bc366e7d0c6b2b9865602725344.jpg)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-[#0a0a0a]" />

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <p className="text-red-500 text-sm font-['Crimson_Text'] tracking-widest uppercase mb-3">
          The Archive
        </p>
        <h1 className="text-5xl md:text-6xl font-bold text-white font-['Cinzel'] mb-4 drop-shadow-2xl">
          Browse <span className="text-red-600">Stories</span>
        </h1>
        <p className="text-gray-400 text-lg font-['Crimson_Text'] mb-10 max-w-2xl mx-auto">
          Lots of dark tales waiting to be discovered. Search, filter, and lose yourself in the horror.
        </p>

        <form onSubmit={handleSubmit} className="relative max-w-2xl mx-auto">
          <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg" />
          <input
            ref={inputRef}
            type="text"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search stories, authors, tags..."
            className="w-full pl-12 pr-32 py-4 bg-black/60 backdrop-blur-sm border border-red-900/40 rounded-lg text-white placeholder-gray-500 text-sm font-['Crimson_Text'] focus:outline-none focus:border-red-600/70 transition-colors"
          />
          <button
            type="submit"
            className="absolute right-2 top-1/2 -translate-y-1/2 px-5 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-semibold rounded-md transition-colors whitespace-nowrap cursor-pointer font-['Crimson_Text']"
          >
            Search
          </button>
        </form>
      </div>
    </section>
  );
};

export default StoriesHero;
